import React,{useEffect,useRef} from "react";
import {loadGoogleMaps} from "../services/maps";

export default function RoutePreviewMap({apiKey,pickup,drop,route}){
  const element=useRef(null),map=useRef(null),line=useRef(null),markers=useRef([]);
  useEffect(()=>{
    let cancelled=false;
    if(!apiKey||!element.current||!route?.polyline||!pickup||!drop)return;
    loadGoogleMaps(apiKey).then(g=>{
      if(cancelled||!element.current)return;
      const path=g.maps.geometry.encoding.decodePath(route.polyline);
      if(!map.current)map.current=new g.maps.Map(element.current,{center:path[0],zoom:10,streetViewControl:false,mapTypeControl:false,fullscreenControl:false});
      if(line.current)line.current.setMap(null);
      markers.current.forEach(m=>m.setMap(null));
      line.current=new g.maps.Polyline({path,geodesic:true,strokeColor:"#466b18",strokeOpacity:.95,strokeWeight:5,map:map.current});
      markers.current=[
        new g.maps.Marker({map:map.current,position:{lat:Number(pickup.lat),lng:Number(pickup.lng)},label:"P",title:"Pickup"}),
        new g.maps.Marker({map:map.current,position:{lat:Number(drop.lat),lng:Number(drop.lng)},label:"D",title:"Delivery"})
      ];
      const bounds=new g.maps.LatLngBounds();path.forEach(p=>bounds.extend(p));map.current.fitBounds(bounds,36);
    }).catch(e=>console.error("GRD route map failed:",e));
    return()=>{cancelled=true};
  },[apiKey,route?.polyline,pickup?.lat,pickup?.lng,drop?.lat,drop?.lng]);
  return <div className="route-map-wrap"><div ref={element} className="route-map" aria-label="Pickup to delivery route map"/><div className="route-map-legend"><span><b className="route-dot pickup-dot"/>Pickup</span><span><b className="route-dot drop-dot"/>Delivery</span></div></div>;
}
